<template>
<div> 
    <div v-if="type=='input_text'">
        <b-form-input v-model="structure.pre_text" placeholder="입력폼 앞쪽에 나타날 텍스트" @update="handleChange"></b-form-input>
        <b-form-input v-model="structure.after_text" placeholder="입력폼 뒤쪽에 나타날 텍스트" @update="handleChange"></b-form-input>
        <b-form-input v-model="structure.placeholder" placeholder="텍스트 입력 가이드" @update="handleChange"></b-form-input>

    </div>

    <div v-else-if="type=='input_number'">
        <b-form-input v-model="structure.pre_text" placeholder="입력폼 앞쪽에 나타날 텍스트" @update="handleChange"></b-form-input>
        <b-form-input v-model="structure.after_text" placeholder="입력폼 뒤쪽에 나타날 텍스트" @update="handleChange"></b-form-input>
        <b-form-input v-model="structure.placeholder" placeholder="텍스트 입력 가이드" @update="handleChange"></b-form-input>
    </div>
    
    <div v-else-if="type=='checkbox'">
        <b-table-simple>
            <tr>
                <td> text </td><td> value </td> <td> description </td> <td> 삭제 </td>
            </tr>
            <tr v-for="(item, index) in structure" :key="item.id">
                <td><b-form-input v-model="item.text" @update="handleChange">{{ item.text }}</b-form-input> </td>
                <td><b-form-input v-model="item.value" @update="handleChange">{{ item.value }}</b-form-input></td>
                <td><b-form-checkbox v-model="is_description_available[index]" @input="manageDescriptionAvailability(item, index)" value="true" unchecked-value="false"> 
                        <b-form-input :disabled="!is_description_available[index]" placeholder="상세 내용 폼에 표시될 가이드텍스트를 입력해 주세요" v-model="item.placeholder" @update="handleChange">
                            {{ item.placeholder }}
                        </b-form-input>
                    </b-form-checkbox>
                </td>
                <td>
                    <b-button @click="deleteCheckboxItem(index)" class="hj-icon-only-btn" size="sm"><fa icon="trash-alt"></fa></b-button>
                </td>
            </tr>
        </b-table-simple>
        <div class="text-right">
            <b-button @click="addCheckboxItem()" variant="blue" size="sm">체크박스 선택지 추가</b-button>
        </div>
    </div>

    <div v-else>
        <b-dropdown :text="type" :disabled="type!=''">
            <b-dropdown-item @click="selectType('input_text')">input_text</b-dropdown-item>
            <b-dropdown-item @click="selectType('input_number')">input_number</b-dropdown-item>
            <b-dropdown-item @click="selectType('checkbox')">checkbox</b-dropdown-item>
        </b-dropdown>
    </div>
    
</div>
</template>
<script>
export default {
    data(){
        return {
            type: '', 
            result: '',
            structure: [],
            
            is_description_available: []
            
            //type: 'input_text', // input_number, input_text
            //result: '',
            //structure: {
            //    pre_text: '시험삼아',
            //    after_text: '해보았습니다',
            //    placeholder: '입력',
            //}

            //type: 'checkbox', // checkbox
            //result: [],
            //structure: [
            //     {
            ///         "text": "이사회 의장이 독립이사임", 
            //          "value": "이사회 의장이 독립이사", 
            //          "description": ""
            //      }, 
            //      {
            //          "text": "이사회 의장이 전 CEO 또는 전 의장임", 
            //          "value": "이사회 의장이 전 CEO 또는 전 의장", 
            //          "description": ""
            //      }, 
            //      {
            //          "text": "이사회 의장이 기타비상무이사임", 
            //          "value": "이사회 의장이 기타비상무이사", 
            //          "description": ""
            //      }, 
            //      {
            //          "text": "이사회 의장이 CEO 또는 사내이사임", 
            //          "value": "이사회 의장이 CEO 또는 사내이사", 
            //          "description": ""
            //      }
            //  ]
        }
    },
    props:{
        item_idx: {type: Number},
        element_idx: {type: Number}, 
        element_item: { type: Object }
    },
    methods:{
        handleChange(){
            let new_item = {
                type: this.type, 
                result: this.result, 
                structure: this.structure
            }
            console.log('event-emit' + this.item_idx + this.element_idx + new_item)
            this.$emit('change', this.item_idx, this.element_idx, new_item)
        },
        selectType(target){
            this.structure = {}
            if(target=='input_text' || target=='input_number'){
                let new_item = {
                    pre_text: '',
                    after_text: '',
                    placeholder: ''
                }
                this.structure = new_item
            }
            else if(target=='checkbox'){
                this.result = []
                this.structure = []
            }
            this.type = target
            this.handleChange()
        },
        manageDescriptionAvailability(item, index){
            Vue.nextTick( () => {
                //해당 checkbox 아이템에 대해 description을 쓴다고 체크한 것이면
                if(this.is_description_available[index] == 'true'){
                    Vue.set(item, 'description', "")
                    Vue.set(item, 'placeholder', "")
                }
                //description을 쓰지 않는다고 체크한 것이면
                else {
                    delete item.description
                    delete item.placeholder
                }

                this.handleChange()

            })
        },
        addCheckboxItem(){
            let new_checkbox_item = {
                text: '',
                value: ''
            }
            this.structure.push(new_checkbox_item)
            this.handleChange()
        },
        deleteCheckboxItem(index){
            this.structure.splice(index,1)
            this.handleChange()
        },
        initiateDescriptionAvailability(){
            for (let i=0; i<this.structure.length; i++)
            {
                if( this.structure[i].hasOwnProperty('description')) this.is_description_available[i] = true
                else this.is_description_available[i] = false
            }
        }
    },
    created(){
        this.type = this.element_item.type
        this.result = this.element_item.result
        this.structure = this.element_item.structure

        if(this.type == 'checkbox'){
            this.initiateDescriptionAvailability()
        }
    }
}
</script>